export default __webpack_public_path__ + "static/media/proclamation2.ab6ef639.jpg";